// import { createTheme } from '@mui/material/styles';
import { experimental_extendTheme as extendTheme } from '@mui/material/styles';
// Components
import { Alert } from './components/Alert';
import { Button } from './components/Button';
import { ButtonGroup } from './components/ButtonGroup';
import { Divider } from './components/Divider';
import { Input, HelperText } from './components/Input';
import { Radio } from './components/Radio';
import { Paper } from './components/Paper';
// Config
import { colors as brandColors } from './colors';
import { typography as brandTypography } from './typography';
import { DataGrid } from './components/DataGrid';

// ! This is the main theme file, where you can override the default MUI theme
// ! You can also create a new theme file and import them here
const brandTheme = extendTheme({
  components: {
    MuiAlert: Alert.MuiAlert,
    MuiButtonBase: Button.MuiButtonBase,
    MuiButton: Button.MuiButton,
    MuiButtonGroupBase: ButtonGroup.MuiButtonGroupBase,
    MuiButtonGroup: ButtonGroup.MuiButtonGroup,
    MuiDivider: Divider.MuiDivider,
    MuiInput: Input.MuiInput,
    MuiTextField: Input.MuiTextField,
    MuiFormHelperText: HelperText.MuiFormHelperText,
    MuiRadio: Radio.MuiRadio,
    MuiDataGrid: DataGrid.MuiDataGrid,
    MuiPaper: Paper.MuiPaper,
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          letterSpacing: '.4px',
          fontSize: '14px',
        },
      },
    },
  },
  palette: {
    ...brandColors,
  },
  colorSchemes: {
    light: {
      palette: {
        ...brandColors,
      },
    },
  },
  typography: {
    ...brandTypography,
  },

  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 768,
  //     md: 900,
  //     lg: 1280,
  //     xl: 1536,
  //   },
  // },
});

export default brandTheme;
